import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName, EmbeddedCode } from '../../../../entities';
import { EmployeeMergeData } from './employee.merge.data';

@MergeSchema({
    entity: ActivityEntityName.WorkOrder,
    name: 'StageMergeSchema',
})
export class StageMergeData {

    @MergeField()
    _id: string;

    @MergeField({ hidden: true })
    jobId: string;

    @MergeField({ displayName: 'Stage Number' })
    workOrderNumber: string;

    @MergeField()
    sortOrder: string = '';

    @MergeField()
    version: number;

    @MergeField()
    name: string;

    @MergeField()
    description: string;

    @MergeField()
    status: string;

    @MergeField()
    createdAt: string;

    @MergeField()
    startDate: string;

    @MergeField()
    dueDate: string;

    @MergeField()
    completedDate: string;

    @MergeField()
    finalisedDate: string;

    @MergeField()
    completedSignature: string;

    @MergeField()
    completedSignatureName: string;

    @MergeField()
    completedNote: string;

    @MergeField()
    finalisedNote: string;

    @MergeField()
    pricebook: string;

    @MergeField()
    totalBuyPrice: string;

    @MergeField()
    totalSellPrice: string;

    @MergeField()
    workCategory: string;

    @MergeField()
    tags: string;

    @MergeField()
    systemTags: string;

    @MergeField({
        arraySchemaName: "EmployeeMergeSchema",
    })
    resources: EmployeeMergeData[];

    @MergeField()
    timezone: string;

    @MergeField()
    nextAppointmentDate: string = ''

    @MergeField()
    nextAppointmentDateTime: string = ''

    @MergeField()
    nextAppointmentResourceName: string = ''

    customFields: any;
    codes?: EmbeddedCode[];
}

export const StageMergeSchema = getSchema(StageMergeData);
